module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-toilet/master-toilet.component.scss
// module id = ./src/app/master/master-toilet/master-toilet.component.scss
// module chunks = main